import sharedConfig from 'app/shared/sharedConfig';

export const ZG_PAYMENTS_ENABLED = 'ZG_PAYMENTS_ENABLED';
export const ZG_APPLICATIONS_ENABLED = 'ZG_APPLICATIONS_ENABLED';
export const ZG_RENTER_INFORM_ENABLED = 'ZG_RENTER_INFORM_ENABLED';
export const INSTANT_APP_ENABLED = 'INSTANT_APP_ENABLED';
export const ZG_APPLICATIONS_VIEWABLE_GROUP = 'ZG_APPLICATIONS_VIEWABLE_GROUP';
export const DEV_BRAND = 'dev_brand';
export const HOST_APP = 'hostApp';
export const ZG_API = 'ZG_API';

export const ZG_CUSTOMER_PAYMENT_ENABLED = 'ZG_CUSTOMER_PAYMENT_ENABLED';

export const ZG_LEAD_GUARANTEE_ENABLED = 'ZG_LEAD_GUARANTEE_ENABLED';

export const ZG_MOCK_USER_ENABLED = 'ZG_MOCK_USER_ENABLED';
export const ZG_MOCK_USER_TOKEN = 'ZG_MOCK_USER_TOKEN';
export const ZG_MOCK_USER_EMAIL = 'ZG_MOCK_USER_EMAIL';
export const ZG_MOCK_USER_IMPERSONATOR_TOKEN = 'ZG_MOCK_USER_IMPERSONATOR_TOKEN';
export const ZG_MOCK_USER_IMPERSONATOR_EMAIL = 'ZG_MOCK_USER_IMPERSONATOR_EMAIL';
export const ZG_MOCK_USER_IS_AUTHENTICATED = 'ZG_MOCK_USER_IS_AUTHENTICATED';
export const ZG_MOCK_USER_HAS_STRONG_PASSWORD = 'ZG_MOCK_USER_HAS_STRONG_PASSWORD';
export const ZG_LISTING_CLAIMING = 'ZG_LISTING_CLAIMING';

const FeatureFlagConstants = {
    [ZG_APPLICATIONS_ENABLED]: false,
    [ZG_PAYMENTS_ENABLED]: false,
    [INSTANT_APP_ENABLED]: false,
    [ZG_RENTER_INFORM_ENABLED]: false,
    [ZG_LISTING_CLAIMING]: false,
    [ZG_CUSTOMER_PAYMENT_ENABLED]: false,

    // lead guarantee
    [ZG_LEAD_GUARANTEE_ENABLED]: false,

    // mocked user
    [ZG_MOCK_USER_ENABLED]: false,
    [ZG_MOCK_USER_TOKEN]: '',
    [ZG_MOCK_USER_EMAIL]: '',
    [ZG_MOCK_USER_IMPERSONATOR_TOKEN]: '',
    [ZG_MOCK_USER_IMPERSONATOR_EMAIL]: '',
    [ZG_MOCK_USER_IS_AUTHENTICATED]: true,
    [ZG_MOCK_USER_HAS_STRONG_PASSWORD]: true,

    // TODO: move those non-boolean values out since they're not
    // strictly features.
    [HOST_APP]: 'none',
    [ZG_APPLICATIONS_VIEWABLE_GROUP]: 'none',
    [DEV_BRAND]: sharedConfig.defaultBrand,
    [ZG_API]: sharedConfig.defaultZgApi,
};

export default FeatureFlagConstants;
